export class Address {
  address1: string = "";
  address2: string = "";
  county: string = "";
  postCode: string = "";
  city: string = "";
  country: string = "";
  country2CharIsoCode :string = "";
  formatted:string="";
}
